<ion-content class="bg-color ion-content user-group">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <mat-card>
        <mat-card-title class="mc-title">
          <span class="table-header">User Group</span>
        </mat-card-title>
        <mat-card-content class="mc-content">
          <div class="table-container">
            <div class="filter-container">
              <div class="button-container">
                <button mat-raised-button class="add-button" routerLink='/baseapp/user-group/add'> Add </button>
                <!-- <button mat-raised-button class="clear-button"> Clear Search</button> -->
              </div>
              <div class="search-container">
                <mat-form-field appearance="fill">
                  <mat-label>Search</mat-label>
                  <input matInput type="text" placeholder="Search by group name, created by, updated by"
                    [(ngModel)]="search" (ngModelChange)="getSearchOnChange($event)">
                  <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
            <table mat-table matTableResponsive [dataSource]="userGroupDataSource">
              <!-- Position Column -->
              <!-- <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef> No. </th>
                <td mat-cell *matCellDef="let element"> {{element.position}} </td>
              </ng-container> -->

              <ng-container matColumnDef="group_name">
                <th mat-header-cell *matHeaderCellDef> Group Name </th>
                <td mat-cell *matCellDef="let element">{{element.group_name}} </td>
              </ng-container>

              <ng-container matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef> Created by </th>
                <td mat-cell *matCellDef="let element">{{element.created_by}} </td>
              </ng-container>

              <ng-container matColumnDef="updated_by">
                <th mat-header-cell *matHeaderCellDef> Updated by </th>
                <td mat-cell *matCellDef="let element">{{element.updated_by}} </td>
              </ng-container>

              <ng-container matColumnDef="created_date">
                <th mat-header-cell *matHeaderCellDef> Created Date </th>
                <td mat-cell *matCellDef="let element"> {{element.created_date | date: 'medium'}} </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon class="icon filter" matTooltip="Filter" matTooltipPosition="above"
                    (click)="userGroupFilters(element.id)"> filter_list
                  </mat-icon>
                  <mat-icon class="icon edit" matTooltip="Edit" matTooltipPosition="above"
                    (click)="editUserGroup(element.id)"> edit
                  </mat-icon>
                  <mat-icon class="icon info" matTooltip="Info" matTooltipPosition="above"
                    (click)="getUserGroupDetails(element.id)">
                    info </mat-icon>
                  <!-- <mat-icon class="mat-ico delete" (click)="confirmDelete(element.id)"> delete </mat-icon> -->
                  <mat-icon class="icon delete"  matTooltip="Delete" matTooltipPosition="above"
                  (click)="confirmDelete(element.id)"> delete </mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="userGroupDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: userGroupDisplayedColumns;"></tr>
            </table>

            <table *ngIf="!loading">
              <tr *ngIf="!userGroupDataSource.length">
                <td style="text-align: center;" [attr.colspan]="userGroupDisplayedColumns.length">
                  No Records Found
                </td>
              </tr>
            </table>
          </div>
        </mat-card-content>
        <!-- <div *ngIf="total_records > 10" class="load-more-bx">
          <button mat-raised-button class="load-more" (click)="loadMore()">Load More</button>
        </div> -->
        <ion-infinite-scroll *ngIf="total_records > 10" threshold="150px" (ionInfinite)="loadMore($event)">
          <ion-infinite-scroll-content loadingSpinner="dots">
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </mat-card>
      <!-- <app-about-page *ngIf="hide1200"></app-about-page> -->
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>